import { AUTO_COMPLETE_DISPLAY_KEYS, SEQ_VALIDATE_REGX } from "@src/constants";
import { SequenceInputTypes } from "@src/types";

const transformRequest = (
  payload: SequenceInputTypes,
  fetch: string | undefined,
  mode: string | undefined
) => {
  let request: any = undefined;
  const codonDefaults =
    fetch === "transcript"
      ? {
          gene_id: "null",
          chromosome: "null",
          start: "null",
          end: "null",
          strand: "null",
          pam_type: "null",
        }
      : {};
  const baseDefaults =
    fetch === "transcript"
      ? { user_input_sequence: "null", pam_type: "null" }
      : {};
  const codonValues = {
    gene_id: payload.gene_id,
    chromosome: payload.chromosome,
    start: payload.start?.toString(),
    end: payload.end?.toString(),
    strand: payload.strand,
  };
  const baseValues = {
    user_input_sequence: SEQ_VALIDATE_REGX.test(payload.user_input_sequence)
      ? payload.user_input_sequence
          .replaceAll(/\n+/g, "\n")
          .replaceAll(/\n[atgc]+/g, (match) => match.toUpperCase())
      : `>sequence\n${payload.user_input_sequence
          .replaceAll(/\n+/g, "\n")
          .replaceAll(/[atgc]+/g, (match) => match.toUpperCase())}`,
    pam_type: payload.pam_type,
  };

  if (payload) {
    if (fetch === "transcript") {
      request = {
        ...payload,
        analysis_stage: "fetch_transcript_list",
        project_id: generateUUID(),
        analysis_module:
          mode === "codon" ? "stop_codon_design" : "dna_base_editor_design",
        cbe_type: undefined,
        gene_id: undefined,
        user_input_sequence: undefined,
      };
    } else if (fetch === "result") {
      request = {
        ...payload,
        analysis_stage:
          mode === "codon"
            ? "stop_codon_design_analysis"
            : "dna_base_editor_analysis",
        analysis_module:
          mode === "codon" ? "stop_codon_design" : "dna_base_editor_design",
        gene_id: undefined,
        chromosome: undefined,
        start: undefined,
        end: undefined,
        strand: undefined,
        pam_type: mode !== "base" ? undefined : payload.pam_type,
      };
    }
  } else {
    throw Error("payload is empty.");
  }
  if (fetch === "transcript")
    return mode === "codon"
      ? { ...request, ...baseDefaults, ...codonValues }
      : { ...request, ...codonDefaults, ...baseValues };
  else
    return {
      ...request,
      user_input_sequence: SEQ_VALIDATE_REGX.test(payload.user_input_sequence)
        ? payload.user_input_sequence
            .replaceAll(/\n+/g, "\n")
            .replaceAll(/\n[atgc]+/g, (match) => match.toUpperCase())
        : `>sequence\n${payload.user_input_sequence
            .replaceAll(/\n+/g, "\n")
            .replaceAll(/[atgc]+/g, (match) => match.toUpperCase())}`,
    };
};

const createAutocompleteDisplayValue = (suggestion: any) =>
  AUTO_COMPLETE_DISPLAY_KEYS?.map(
    (key: string, idx: number) => suggestion[key]
  ).join(" | ");

const generateUUID = () => {
  return "xxxx-xxxx-4xxx-yxxx-xxx".replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

const timestampForFileName = () => {
  const isAM = new Date().toLocaleTimeString().includes("AM");
  const date = new Date().toLocaleDateString();
  const time = new Date().toLocaleTimeString().split(" ")[0];
  const time24 = isAM
    ? Number(time.split(":")[0])
    : Number(time.split(":")[0]) + 12;
  const arrTime = time.split(":");
  arrTime.shift();
  arrTime.unshift(time24.toString());
  return `${date.replaceAll("/", "")}_${arrTime.join("")}`;
};

export {
  transformRequest,
  createAutocompleteDisplayValue,
  generateUUID,
  timestampForFileName,
};
